import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import { apiFetch } from "../api/apiClient";

export default function AttachmentsList({ jobId, onDelete }) {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAttachments();
  }, [jobId]);

  const fetchAttachments = async () => {
    try {
      const res = await apiFetch(`/jobs/${jobId}/attachments`);
      const data = await res.json();
      setAttachments(data);
    } catch (error) {
      console.error("Failed to fetch attachments:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (attachmentId, fileName) => {
    try {
      const res = await apiFetch(`/attachments/${attachmentId}/download`);
      const blob = await res.blob();

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleDelete = async (attachmentId) => {
    if (!window.confirm("Are you sure you want to delete this attachment?"))
      return;

    try {
      await apiFetch(`/attachments/${attachmentId}`, { method: "DELETE" });
      setAttachments(attachments.filter((a) => a.pk_id !== attachmentId));
      if (onDelete) onDelete(attachmentId);
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  if (loading) return <CircularProgress />;

  if (attachments.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No attachments
      </Typography>
    );
  }

  return (
    <List>
      {attachments.map((attachment) => (
        <ListItem key={attachment.pk_id}>
          <ListItemText
            primary={attachment.file_name}
            secondary={`Uploaded by ${
              attachment.uploaded_by_username
            } on ${new Date(attachment.uploaded_at).toLocaleString()}`}
          />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() =>
                handleDownload(attachment.pk_id, attachment.file_name)
              }
            >
              <DownloadIcon />
            </IconButton>
            <IconButton onClick={() => handleDelete(attachment.pk_id)}>
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
}
